import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import { StoppageStore } from '@operations/stores/StoppageStore'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { StoppageRecord } from './molecules/StoppageRecord'

interface Props {
  store: StoppageStore
  visitId: number
  isVisitDeparted?: boolean
  isVesselVisit?: boolean
  onViewClick: (e: any) => void
}

export const StoppagesSummary = observer(
  ({ store, visitId, isVisitDeparted, isVesselVisit, onViewClick }: Props) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    useAsyncFetch(async () => {
      await store.fetchDataByVisitId(visitId)
      store.setSelectedVisitId(visitId)
    }, [store, visitId])

    const gridSize = computed(() =>
      store.orderedItems.length >= 3 ? 4 : 12 / store.orderedItems.length,
    ).get()

    return (
      <Card sx={{ width: '100%', height: '100%' }}>
        <CardHeader
          action={
            <Button color='inherit' onClick={onViewClick} data-cy='stoppages-view-btn'>
              {t('view', 'View')}
            </Button>
          }
          title={<Typography variant='h2'>{t('stoppages', 'Stoppages')}</Typography>}
        />
        <CardContent>
          <Stack gap={theme.customSpacing.xs}>
            {store.orderedItems.length ? (
              <>
                <Typography variant='subtitle2'>{t('lastRecorded', 'Last recorded')}</Typography>

                <Grid container rowGap={theme.customSpacing.l}>
                  {store.orderedItems
                    .filter((_, index) => index < 3)
                    .map(item => (
                      <Grid
                        key={item.id}
                        size={{
                          xs: 12,
                          md: gridSize,
                        }}
                      >
                        <StoppageRecord stoppage={item} isVesselVisit={isVesselVisit} />
                      </Grid>
                    ))}
                </Grid>

                {isVisitDeparted && (
                  <Alert severity='warning'>
                    {t('thereAreOpenStoppages', 'There are {open} open stoppages', {
                      open: store.openStoppages,
                    })}
                  </Alert>
                )}
              </>
            ) : (
              <Typography variant='body2'>
                {t('noStoppagesRecorded', 'No stoppages recorded')}
              </Typography>
            )}
          </Stack>
        </CardContent>
      </Card>
    )
  },
)
